import storage from "store2";

export function deleteToken() {
  storage.local.clearAll();
}